/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import pr from "../lib/pr";

// 등록하기 팝업
function MemberAdd (props) {
    const { login, onCloseAddPop } = props;
    const token = localStorage.getItem('token');
  
    // 데이타폼
    const [data, setData] = useState({    
      token:token,
      ccid:login.ccid,
      level:login.level,
      name: "",
      phone: "",
      sex: "",
      birth: "0000-00-00",
      weight: "",
      avatar: ""
    });
  
    const onHandleData = (e) => {
      setData((state) => {
        return { ...state, [e.target.name]: e.target.value };
      });
    };
  
    // 아바타 데이타
    const avatar_data = [
      '01','02','03','04','05','06','07','08','09','10',
      '11','12','13','14','15','16','17','18'  
    ]
  
    const onSubmit = async() => {
  
      let result = await axios.post(configState.api+'/hr/add_member',data);
      if(result.data.success !== 1) {
        Swal.fire(result.data.msg);
        return;
      }
      else {
        Swal.fire({title:'등록되었습니다.', showCloseButton:true}).then((result)=>{
          onCloseAddPop();
        });
      }
    };  
  
    return (
      <Box>
        <Box
          css={css`
            padding: 20px 60px;
          `}
        >
          <h3>회원등록</h3>
          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="name"
              label="이름"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onHandleData}
              autoComplete="off"
            ></TextField>
          </Box>
          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="phone"
              label="연락처 : -없이 입력"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onHandleData}
              autoComplete="off"
            ></TextField>
          </Box>
          <FormControl
            fullWidth
            css={css`
              margin-top: 10px;
            `}          
          >
            <InputLabel id="label1">성별</InputLabel>
            <Select 
            label="성별"
            labelId="label1"
            name="sex" size="small"
            onChange={ onHandleData }
            value={data.sex}
            >
              <MenuItem value="남">남</MenuItem>
              <MenuItem value="여">여</MenuItem>
            </Select>
          </FormControl>
          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="birth"
              label="생일 YYYY-MM-DD"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onHandleData}
              autoComplete="off"
            ></TextField>
          </Box>
          <Box
            css={css`
              margin-top: 10px;
            `}
          >
            <TextField
              name="weight"
              label="몸무게"
              size="small"
              style={{
                width: "100%",
              }}
              onChange={onHandleData}
              autoComplete="off"
            ></TextField>
          </Box>
  
          <FormControl
            fullWidth
            css={css`
              margin-top: 10px;
            `}          
          >
            <InputLabel id="label2">아바타</InputLabel>
            <Select 
            label="아바타"
            labelId="label2"
            name="avatar" size="small"
            onChange={ onHandleData }
            value={data.avatar}
            >       
              { avatar_data.map((item, index)=>{
                const  src = '/avatar_img/'+item+'.png';
                return <MenuItem key={index} value={item}><img src={src} height="40"></img></MenuItem>
              })}                            
            
            </Select>
          </FormControl>
  
          <Box
            css={css`
              text-align: center;
              margin-top: 30px;
            `}
          >
            <Button variant="contained" onClick={onSubmit}>
              등록완료
            </Button>
            <Button
              variant="contained"
              color="warning"
              css={css`
                margin-left: 10px;
              `}
              onClick={onCloseAddPop}
            >
              취소
            </Button>
          </Box>
        </Box>
      </Box>
    );
  };

  export default MemberAdd;